var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5217C0 8.13872 0 5.94721 0.852992 4.27312C1.60331 2.80054 2.80054 1.60331 4.27312 0.852992C5.94721 0 8.13872 0 12.5217 0H23.4783C27.8613 0 30.0528 0 31.7269 0.852992C33.1995 1.60331 34.3967 2.80054 35.147 4.27312C36 5.94721 36 8.13872 36 12.5217V23.4783C36 27.8613 36 30.0528 35.147 31.7269C34.3967 33.1995 33.1995 34.3967 31.7269 35.147C30.0528 36 27.8613 36 23.4783 36H12.5217C8.13872 36 5.94721 36 4.27312 35.147C2.80054 34.3967 1.60331 33.1995 0.852992 31.7269C0 30.0528 0 27.8613 0 23.4783V12.5217Z",
    fill: "url(#paint0_linear_3842_45367)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3749 17.7243C12.7436 15.4664 16.3236 13.9778 18.1148 13.2585C23.2292 11.205 24.2919 10.8483 24.9846 10.8366C25.1369 10.834 25.4776 10.8704 25.6982 11.0432C25.8845 11.1892 25.9358 11.3863 25.9603 11.5247C25.9848 11.6631 26.0154 11.9783 25.9911 12.2245C25.714 15.0356 24.5147 21.8574 23.9046 25.0059C23.6465 26.3381 23.1382 26.7848 22.6461 26.8285C21.5766 26.9235 20.7645 26.1462 19.7287 25.4908C18.1078 24.4651 17.1921 23.8266 15.6188 22.8258C13.8005 21.6691 14.9792 21.0334 16.0154 19.9944C16.2866 19.7225 20.9987 15.5851 21.0899 15.2098C21.1013 15.1628 21.1119 14.9879 21.0042 14.8955C20.8965 14.8031 20.7376 14.8347 20.6229 14.8598C20.4604 14.8954 17.871 16.5475 12.8549 19.8162C12.1199 20.3034 11.4542 20.5408 10.8577 20.5283C10.2001 20.5146 8.93528 20.1694 7.99498 19.8744C6.84166 19.5125 5.92503 19.3211 6.00485 18.7065C6.04642 18.3864 6.5031 18.059 7.3749 17.7243Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3842_45367",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.2132696f57c6e49db3641f5aa5383ca4.svg";
export { ForwardRef as ReactComponent };